import { render } from "./VimeoCustom.vue?vue&type=template&id=0e168dd3&scoped=true"
import script from "./VimeoCustom.vue?vue&type=script&lang=js"
export * from "./VimeoCustom.vue?vue&type=script&lang=js"

import "./VimeoCustom.vue?vue&type=style&index=0&id=0e168dd3&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e168dd3"]])

export default __exports__